// Visual/static data; all display strings come from i18n/translations.js
import {
  GraduationCap, Users, HeartHandshake, Sparkles, Sprout, Stethoscope, HandHeart,
  BookOpen, Baby, Rocket, Trees, Activity, Award, Building2, Scale, Wrench, Handshake,
} from 'lucide-react';

export const HERO_IMAGE =
  'https://images.unsplash.com/photo-1587538018365-2a1f8b544c08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxydXJhbCUyMEluZGlhJTIwdmlsbGFnZSUyMHdvbWVufGVufDB8fHx8MTc4MjU2MjY0MXww&ixlib=rb-4.1.0&q=85';

export const PROGRAMS = [
  { key: 'education', icon: GraduationCap, image: 'https://images.unsplash.com/photo-1629872928185-171e13c8e58b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxJbmRpYW4lMjBzY2hvb2wlMjBjaGlsZHJlbnxlbnwwfHx8fDE3ODI1NjI2NDh8MA&ixlib=rb-4.1.0&q=85' },
  { key: 'women', icon: Users, image: 'https://images.unsplash.com/flagged/photo-1577604981316-298e453a19dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjB3b21lbiUyMGVtcG93ZXJtZW50fGVufDB8fHx8MTc4MjU2MjY1M3ww&ixlib=rb-4.1.0&q=85' },
  { key: 'child', icon: HeartHandshake, image: 'https://images.unsplash.com/photo-1524069290683-0457abfe42c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxJbmRpYSUyMGNvbW11bml0eSUyMHNlcnZpY2V8ZW58MHx8fHwxNzgyNTYyNjQxfDA&ixlib=rb-4.1.0&q=85' },
  { key: 'youth', icon: Sparkles, image: 'https://images.unsplash.com/photo-1569173675610-42c361a86e37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxJbmRpYW4lMjBzY2hvb2wlMjBjaGlsZHJlbnxlbnwwfHx8fDE3ODI1NjI2NDh8MA&ixlib=rb-4.1.0&q=85' },
  { key: 'rural', icon: Sprout, image: 'https://images.pexels.com/photos/29039798/pexels-photo-29039798.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { key: 'health', icon: Stethoscope, image: 'https://images.unsplash.com/photo-1773140278162-fd7df1043f0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxJbmRpYSUyMGhlYWx0aGNhcmUlMjBtZWRpY2FsfGVufDB8fHx8MTc4MjU2MjY0OHww&ixlib=rb-4.1.0&q=85' },
  { key: 'community', icon: HandHeart, image: 'https://images.unsplash.com/photo-1662101875545-0b0cb8b7795b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxJbmRpYSUyMGNvbW11bml0eSUyMHNlcnZpY2V8ZW58MHx8fHwxNzgyNTYyNjQxfDA&ixlib=rb-4.1.0&q=85' },
];

export const OBJECTIVES = [
  { key: 'education', icon: BookOpen },
  { key: 'welfare', icon: Baby },
  { key: 'youth', icon: Rocket },
  { key: 'rural', icon: Trees },
  { key: 'health', icon: Activity },
  { key: 'scholarship', icon: Award },
  { key: 'community', icon: Building2 },
  { key: 'justice', icon: Scale },
  { key: 'skill', icon: Wrench },
  { key: 'partnership', icon: Handshake },
];

export const COUNCIL_LEVELS = ['state', 'district', 'taluk', 'gram_panchayat', 'general'];

export const NAV_LINKS = [
  { id: 'home', tKey: 'nav.home', href: '/#home', type: 'scroll' },
  { id: 'objectives', tKey: 'nav.objectives', href: '/#objectives', type: 'scroll' },
  { id: 'programs', tKey: 'nav.programs', href: '/#programs', type: 'scroll' },
  { id: 'council', tKey: 'nav.council', href: '/#council-teaser', type: 'scroll', scrollId: 'council-teaser' },
];

export const FOOTER_LINKS = NAV_LINKS;

export const CONTACT_PHONE = '+91 98XXX XXXXX';
export const CONTACT_EMAIL = 'info@jaibheemsevasangha.org';
